<mat-form-field>
  <mat-label>{{ ("language" | i18n) || "Sprache" | titlecase }}</mat-label>
  <mat-select
    [ngModel]="selectedValue$ | async"
    name="languageSelect"
    (selectionChange)="selectionChanged($event.value)"
    [disabled]="!!(isDisabled$ | async)"
    data-cy="language-input">
    <mat-option [value]="null"> - </mat-option>
    <mat-option
      *ngFor="let language of languageEnum | enumToArray"
      [value]="languageEnum[language]">
      {{ ("languageEnum." + languageEnum[language] | i18n) || language }}
    </mat-option>
  </mat-select>
  <mat-hint
    align="end"
    *ngIf="hintContent">
    <ng-container *ngTemplateOutlet="hintContent"></ng-container>
  </mat-hint>
</mat-form-field>
